import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import state from "../../../layouts/beforeAuth/login/Redux/state";
import {
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { clearError, fetchAdminData, login, sendEmailOtp, verifyEmailOtp } from "./Redux/actionCreator";
import logo from "../../../assets/images/logo.png";
import { useForm } from 'react-hook-form';
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginValidation } from "util/validations/loginValidation";
  // const otpInputs = Array(6).fill(0).map(() => useRef(null));
  
  const Login = () => {
  const otpInputs = useRef([]);
  const { register, handleSubmit, formState: { errors }, formState, reset } = useForm({
    resolver: yupResolver(loginValidation)
  });

  // OTP Verification state
  const [showOtpDialog, setShowOtpDialog] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [otpDigits, setOtpDigits] = useState(['', '', '', '']);
  // const handleOtpChange = (index, value) => {
  //   if (isNaN(value)) return;
  
  //   const newOtp = [...otpDigits];
  //   newOtp[index] = value;
  //   setOtpDigits(newOtp);
  
  //   // Move focus to next box
  //   if (value && index < otpInputs.current.length - 1) {
  //     otpInputs.current[index + 1]?.focus();
  //   }
  // };

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);

    if (value && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1]?.focus();
    }
  };

  
  // const handleOtpKeyDown = (index, e) => {
  //   if (e.key === 'Backspace' && !otpDigits[index] && index > 0) {
  //     otpInputs.current[index - 1]?.focus();
  //   }
  // };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      const newOtp = [...otpDigits];

      if (newOtp[index]) {
        // current digit clear
        newOtp[index] = "";
        setOtpDigits(newOtp);
      } else if (index > 0) {
        // move back & clear previous
        otpInputs.current[index - 1]?.focus();
        newOtp[index - 1] = "";
        setOtpDigits(newOtp);
      }
    }
  };


  // const handleOtpKeyDown = (index, e) => {
  //   if (e.key === "Backspace") {
  //     e.preventDefault();

  //     const newOtp = [...otpDigits];

  //     if (newOtp[index]) {
  //       // current digit clear
  //       newOtp[index] = "";
  //       setOtpDigits(newOtp);
  //     } else if (index > 0) {
  //       // move back & clear previous
  //       otpInputs.current[index - 1]?.focus();
  //       newOtp[index - 1] = "";
  //       setOtpDigits(newOtp);
  //     }
  //   }
  // };

  

  const handleVerifyOtp = async () => {
    try {
      const otp = otpDigits.join("");
      if (otp.length !== 4) return;

      setOtpLoading(true);
      setOtpError("");

      const result = await dispatch(
        verifyEmailOtp({ otp, verifyOtpToken })
      ).unwrap();

      if (result?.data?.success) {
        setShowOtpDialog(false);
        toast.success(result?.data?.message || "Login successful");
      } else {
        throw new Error("Invalid OTP");
      }
    } catch (err) {
      setOtpError("Invalid OTP. Please try again.");
      toast.error("Invalid OTP. Please try again.");
      setOtpDigits(["", "", "", ""]);
      otpInputs.current[0]?.focus();
    } finally {
      setOtpLoading(false);
    }
  };


  //for validating email
  const isValidEmail = (email) => {
    return (
      String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) !== null
    );
  };

  //for validating password
  const isValidPassword = (password) => {
    return password.length > 3;
  };

  const validation = {
    email: isValidEmail,
    password: isValidPassword,
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, t_id, success ,verifyOtpToken} = useSelector((state) => state.auth);
  
  

  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    isRememberMe: true,
  });

  const [validationState, setValidationState] = useState({
    email: null,
    password: null,
  });

  const handleCredsChange = (e) => {

    const { name, value } = e.target;
    setValidationState((prev) => ({
      ...prev,
      [name]: validation[name](value),
    }));
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 

  const handleResendOtp = useCallback(async () => {
    try {
      const data={email: localStorage.getItem("email_id")}
      await dispatch(sendEmailOtp(data)).unwrap();
      // Here you would typically resend the OTP
      // For now, we'll just show a toast
      toast.success('New OTP sent to your email');
      return true;
    } catch (error) {
      toast.error('Failed to resend OTP. Please try again.');
      console.error('Failed to resend OTP:', error);
      return false;
    }
  }, []);

 const onSubmit = async (data) => {
  try {
    console.log("Attempting login...");
    const result = await dispatch(login(data)).unwrap();
    console.log("Login result:", result);
    console.log("Login result........",
      window.localStorage.getItem("t_id"),
      window.localStorage.getItem("temp_token"),
      window.localStorage.getItem("email_id")
    );
    if(result ){
    setShowOtpDialog(true);
   dispatch(sendEmailOtp(data));
    }
  } catch (error) {
    console.error('Login failed:', error);
    // toast.error(error?.msg || 'Login failed. Please try again.');
  }
};

  const toTop = () => {

    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
// const handleVerifyOtp = async () => {
//   try {
//     const otp = otpDigits.join('');
//     if (otp.length !== 4) {
//       toast.error("Please enter a valid 4-digit OTP");
//       return;
//     }

//     setOtpLoading(true);
//     setOtpError('');
    
//     console.log("Verifying OTP...",verifyOtpToken);
//     const result =  await dispatch(verifyEmailOtp({
//       otp: otp,
//       verifyOtpToken: verifyOtpToken
//     })).unwrap();
    
//     console.log("OTP verification successful=====",result);
//     if(result?.data?.success){
//       setShowOtpDialog(false);
//       toast.success(result?.data?.message, {
//         position: "top-right",
//       });
//       console.log("Navigating to home...");
//       console.log("t_id valuee:", window.localStorage.getItem("t_id"));
      
//       // Admin data will be fetched by the t_id effect after state update
      
//     }else{
//       toast.error(result?.error?.message, {
//         position: "top-right",
//       });
//     }
//   } catch (error) {
//     console.error('OTP verification failed:', error);
//     setOtpError(error || 'Invalid OTP. Please try again.');
//   } finally {
//     setOtpLoading(false);
//   }
// };

useEffect(() => {
  const otp = otpDigits.join("");
  if (otp.length === 4) {
    const timer = setTimeout(handleVerifyOtp, 300);
    return () => clearTimeout(timer);
  }
}, [otpDigits]);


  // useEffect(() => {
  //   const otp = otpDigits.join("");
  //   if (otp.length === 4 && !otpLoading) {
  //     handleVerifyOtp();
  //   }
  // }, [otpDigits]);


  const handleCloseOtpDialog = () => {
    setShowOtpDialog(false);
    setOtpError('');
    reset();
  };
  // Fetch admin data on initial load if user is already logged in
  useEffect(() => {
    const email = localStorage.getItem("email_id");
    const token = localStorage.getItem("t_id");
    
    if (token && email) {
      dispatch(fetchAdminData(email));
      navigate("/home");
      toTop();
    }
  }, []);

  // Handle redirection after successful OTP verification
  useEffect(() => {
    if (t_id) {
      const email = localStorage.getItem("email_id");
      if (email) {
        dispatch(fetchAdminData(email));
        navigate("/home");
        toTop();
      }
    }
  }, [t_id]);

  if (error) {
    setTimeout(() => {
      dispatch(clearError());
    }, 3000);
  }
  // Render OTP Dialog

  const renderOtpDialog = () => (
    <Dialog
      open={showOtpDialog}
      onClose={handleCloseOtpDialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
        <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
          OTP Verification
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", px: 4, py: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We've sent a verification code to{" "}
          <strong>{localStorage.getItem("email_id")}</strong>
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Please enter the 4-digit code to continue
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mb: 3,
          }}
        >
          {[0, 1, 2, 3].map((index) => (
            <TextField
              key={index}
              value={otpDigits[index]}
              inputRef={(el) => (otpInputs.current[index] = el)}
              onChange={(e) => handleOtpChange(index, e.target.value)}
              onKeyDown={(e) => handleOtpKeyDown(index, e)}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "1.5rem",
                  height: "50px",
                  width: "40px",
                },
              }}
              disabled={otpLoading}
            />
          ))}
        </Box>

        {otpError && (
          <Typography color="error" variant="body2" sx={{ mb: 2 }}>
            {otpError}
          </Typography>
        )}

        <Box sx={{ textAlign: "center", mt: 2, mb: 2 }}>
          <Button
            onClick={handleResendOtp}
            disabled={otpLoading}
            color="primary"
            variant="text"
            sx={{ textTransform: "none" }}
          >
            Resend Code
          </Button>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0, justifyContent: "center" }}>
        <Button
          onClick={handleCloseOtpDialog}
          disabled={otpLoading}
          variant="outlined"
          sx={{
            backgroundColor: "#fff",
            mr: 2,
            minWidth: "120px",
            color: "#000",
            borderColor: "#ccc",
            ":hover": {
              backgroundColor: "#f5f5f5",
              borderColor: "#999",
            },
          }}
          // sx={{ mr: 2, minWidth: '120px' }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleVerifyOtp} // In a real app, get the actual OTP from the input fields
          variant="contained"
          color="primary"
          disabled={otpLoading}
          sx={{ minWidth: "120px" }}
        >
          {otpLoading ? <CircularProgress size={24} /> : "Verify"}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <>
      {renderOtpDialog()}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          style={{
            display: "flex",
            border: "2px solid #fff",
            padding: "1rem",
            borderRadius: "10px",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            background: "#fff",
            top: "30%",
            left: "20%",
          }}
        >
          <div className="containerLeft">
            <img src={logo} style={{ width: "20rem" }} />
          </div>
          <hr
            style={{
              width: "12rem",

              transform: "rotate(90deg)",
            }}
          />
          <div
            className="containerRight"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Email
              </Typography>
              <TextField
                placeholder="Enter Email"
                name="email"
                type="email"
                variant="outlined"
                style={{ margin: "0.5rem", marginTop: "0rem" }}
                onInput={() => localStorage.setItem("key", "1")}
                {...register("email")}
                errors={errors?.email?.message}
                helperText={errors?.email?.message}
              />
            </div>

            <div style={{ marginTop: "1rem", alignItems: "left" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Password
              </Typography>
              <TextField
                placeholder="Enter password"
                type="password"
                name="password"
                variant="outlined"
                onInput={() => localStorage.setItem("key", "1")}
                {...register("password")}
                errors={errors?.password?.message}
                helperText={errors?.password?.message}
              />
            </div>
            {formState.isValid ? <Button

              type="submit"
              variant="contained"
              style={{ marginTop: "2rem" }}
            >
              Sign In
            </Button> : <Button
              disabled
              type="submit"
              variant="contained"
              style={{ marginTop: "2rem" }}
            >
              Sign In
            </Button>}

          </div>
        </div>
      </form>
    </>
  );
};

export default Login;
